module.exports = __webpack_public_path__ + "img/block_bg_4_1.7745628d.png";